import { Injectable } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { ApiClientService } from '../../services/api-client.service';

@Injectable()
export class CloseAccountReasonsService extends ApiClientService {
  urlPath: string = `/close_account_reasons`;

  constructor(api: ApiService) {
    super(api);
  }
}
